import styled from 'styled-components';
import { Divider } from 'antd';

export default styled(Divider)`
  margin: 0;
`;
